import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  getFeatureFlagFromParams,
  isFeatureFlagEnabled,
  setFeatureFlagCookie,
} from "@/react/utils/featureFlagCookies";

const COOKIE_NAME = "google_signup";

/**
 * Hook to determine eligibility for Google signup option.
 * Precedence: 1) URL param, 2) cookie
 */
export const useIsGoogleSignupEnabled = (): {
  isGoogleSignupEnabled: boolean;
  isLoading: boolean;
} => {
  const [isGoogleSignupEnabled, setIsGoogleSignupEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { search } = useLocation();

  useEffect(() => {
    const paramValue = getFeatureFlagFromParams(search, "google_signup");
    if (paramValue !== null) {
      setFeatureFlagCookie(COOKIE_NAME, paramValue);
      setIsGoogleSignupEnabled(paramValue === "true");
    } else if (isFeatureFlagEnabled(COOKIE_NAME)) {
      setIsGoogleSignupEnabled(true);
    } else {
      setIsGoogleSignupEnabled(false);
    }
    setIsLoading(false);
  }, [search]);

  return {
    isGoogleSignupEnabled,
    isLoading,
  };
};
